import { TableCard } from '../../../../../components'
import { ImportacaoResumo } from '../../components/ImportacaoResumo'
import { ImportacaoDetalheListTable } from '../table/ImportacaoDetalheListTable'

export const ImportacaoDetalheList = () => {
  return (
    <>
      <ImportacaoResumo />
      <TableCard>
        <ImportacaoDetalheListTable />
      </TableCard>
    </>
  )
}
